import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function fetchStudySession(id, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/study_sessions/${id}`,
    body: fetchParams,
    requestKey,
  });
}

export function fetchStudySessions(fetchParams, requestKey, page, cacheGroupKey) {
  return standardApiRequestAction({
    path: '/api/v1/study_sessions',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
    cacheGroupKey,
  });
}

export function createStudySession(body) {
  return standardApiRequestAction({
    path: '/api/v1/study_sessions',
    method: 'post',
    body,
  });
}

export function updateStudySession(id, body) {
  return standardApiRequestAction({
    path: `/api/v1/study_sessions/${id}`,
    method: 'patch',
    body,
  });
}

export function deleteStudySession(id) {
  return standardApiRequestAction({
    path: `/api/v1/study_sessions/${id}`,
    method: 'delete',
    destroy: { studySessions: [id] },
  });
}

export function fetchInstructorStudySessions({ instructor_id, ...fetchParams }, requestKey, page, cacheGroupKey) {
  return standardApiRequestAction({
    path: `/api/v1/study_sessions/instructor/${instructor_id}`,
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
    cacheGroupKey,
  });
}

export function syncStudySessionWithZoom(id) {
  return standardApiRequestAction({
    path: `/api/v1/study_sessions/${id}/zoom_sync`,
    method: 'put',
  });
}

export function cloneStudySession(id, body) {
  return standardApiRequestAction({
    path: `/api/v1/study_sessions/${id}/clone`,
    method: 'put',
    body,
  });
}

export function fetchStudySessionRecording(ssId, attachmentShareId, deviceUuid, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/study_sessions/${ssId}/recordings/${attachmentShareId}`,
    method: 'put',
    requestKey,
    body: { device_uuid: deviceUuid },
  });
}
